import { Button } from '@/components'
import Image from 'next/image'

import fogueteLogo from '/public/images/countdown_logo.webp'
import fogueteLogoPlay from '/public/images/foguete-play-transparent.webp'
import fogueteLogoAnniversary from '/public/images/anniversary/anniversary-logo.webp'
import fogueteLogoAnniversaryPlans from '/public/images/anniversary/anniversary-plans.webp'

import styles from './styles.module.scss'

const FullCountdown = ({
  text,
  hasHour,
  hasTimer = true,
  isMobile,
  timeLeft,
  percent,
  hasCta,
  variant = '',
  buttonTextColor,
  openModal,
  isLive = true,
  hasPercent = true,
  bottomText = '',
  buttonColor,
  prefixPercent = ''
}) => {
  const liveWidth = isMobile ? 116 : 224
  const liveHeight = isMobile ? 20 : 102

  const product = variant === '' ? (isLive ? 'live' : 'play') : variant

  const logo = {
    live: { src: fogueteLogo, width: liveWidth, height: liveHeight },
    play: { src: fogueteLogoPlay, width: 217, height: 80 },
    anniversary: {
      src: fogueteLogoAnniversary,
      width: 152,
      height: 143
    },
    anniversaryPlans: {
      src: fogueteLogoAnniversaryPlans,
      width: 189,
      height: 146
    }
  }

  return (
    <>
      <div className={styles.leftSection}>
        {!isMobile && (
          <div className={styles.headerLogo}>
            <Image
              className={styles.logo}
              src={logo[product].src}
              alt="Logo"
              width={logo[product].width}
              height={logo[product].height}
            />
          </div>
        )}
        {hasTimer ? (
          <div className={styles.panel}>
            <p className={styles.text}>{text}</p>
            <div className={styles.countdown}>
              {hasHour && (
                <>
                  <div className={styles.timeUnit}>
                    <div className={styles.timeCircle}>
                      {timeLeft.hours.toString().padStart(2, '0')}
                    </div>
                    <span>HORAS</span>
                  </div>
                  <span className={styles.colon}>:</span>
                </>
              )}
              <div className={styles.timeUnit}>
                <div className={styles.timeCircle}>
                  {timeLeft.minutes.toString().padStart(2, '0')}
                </div>
                <span>MIN</span>
              </div>
              <span className={styles.colon}>:</span>
              <div className={styles.timeUnit}>
                <div className={styles.timeCircle}>
                  {timeLeft.seconds.toString().padStart(2, '0')}
                </div>
                <span>SEG</span>
              </div>
            </div>
          </div>
        ) : (
          <p className={styles.bottomText}>{bottomText}</p>
        )}
      </div>

      {(hasCta || hasPercent) && (
        <div className={styles.rightSection}>
          {hasPercent && (
            <div className={styles.discount}>
              <span className={styles.small}>{prefixPercent}</span> {percent}%{' '}
              <span>OFF</span>
            </div>
          )}
          {hasCta && (
            <Button
              className={styles.ctaButton}
              variant={buttonColor || 'yellow'}
              textVariant={buttonTextColor}
              id={'topbar-button-fixed'}
              onClick={() => openModal()}
            >
              Eu quero!
            </Button>
          )}
        </div>
      )}
    </>
  )
}

export default FullCountdown
